import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { Divider } from "@material-ui/core";
import CountUp from "react-countup";
import EcoIcon from "@material-ui/icons/Eco";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import CircularProgress from "@material-ui/core/CircularProgress";
import services from "../services";
import { CollectionCount } from "../components/collectionCount";
import { CommonDecryptParam } from "../../../../utils/CommonParams";
import { LoadingSpinerComponent } from '../../../Common/loader';
import { PageHeader } from '../../../Common';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#fffff",
  },
  rootx: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(5),
    },
  },

  bar: {
    backgroundColor: "#424242",
  },
  txt: {
    color: "#ffffff",
    backgroundColor: "#424242",
  },
  paper: {
    backgroundColor: "#424242",
  },

  large: {
    width: theme.spacing(20),
    height: theme.spacing(20),
  },
  title: {
    fontSize: 14,
  },
  card1: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
    paddingInlineStart: "10px",
    borderRadius: "10px",
    boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
    maxHeight: 300,
    height: 150,
  },
  card2: {
    borderRadius: "10px",
    backgroundColor: "#fffff",
    paddingInlineStart: "10px",
    boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

    height: 150,
  },

  card3: {
    borderRadius: "10px",
    backgroundColor: "#fffff",
    paddingInlineStart: "10px",
    boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

    height: 150,
  },
  card4: {
    borderRadius: "10px",
    backgroundColor: "#fffff",
    paddingInlineStart: "10px",
    boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

    height: 250,
  },
  centertitle: {
    color: "#000000",
    fontSize: 30,
    textAlign: "center",
  },

  profImage: {
    paddingLeft: "50px",
  },
  centertitleCurrency: {
    fontSize: 30,
    textAlign: "center",
    color: "#000000",
  },
}));

export function SupplierProfile(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [supplierDetails, setSupplierDetails] = useState({});
  const [supplierBio, setSupplierBio] = useState({});
  const [factoryItems, setFactoryItems] = useState({
    factoryItemName: "",
    requestedQuantity: "",
    approvedQuantity: "",
    createdDate: "",
  });
  const [balance, setBalance] = useState({
    currentBalance: "",
    runningBalance: "",
  });
  const [lastCollection, setLastCollection] = useState([]);
  const [lastAdvance, setLastAdvance] = useState({
    collectionPointID: "",
    advanceAmount: "",
    issuedDate: "",
  });
  const [lastPayment, setLastPayment] = useState({
    paidAmount: "",
    paidMonth: "",
    issuedDate: "",
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const encriptedTest = props.match.params["id"];
  const id =
    encriptedTest !== undefined
      ? CommonDecryptParam(props.match.params["id"])
      : 0;


  useEffect(() => {
    getDetails();
    getAvatar();
    getBalanceById();
    getFactoryItems();
    getLastCollection();
    getLastAdvance();
    getLastPayment();
  }, []);

  async function getBalanceById() {
    const result = await services.getCustomerBalanceByID(id);
    if (result != null) {
      setBalance({
        currentBalance: result.currentBalance,
        runningBalance: result.runningBalance,
      });
    }
  }

  async function getFactoryItems() {
    const result = await services.getFactoryItemsByCustomer(id);

    setFactoryItems(result);
  }

  async function getDetails() {
    const result = await services.getCustomerByID(id);
    setSupplierDetails(result);
  }

  async function getAvatar() {
    const result = await services.getBiometrics(id, 1);
    setSupplierBio(result);
  }

  function setAvatar() {
    if (supplierBio == null) {
      return (
        <div className={classes.profImage}>
          <Avatar alt="Remy Sharp" className={classes.large} />
        </div>
      );
    } else {
      return (
        <div className={classes.profImage}>
          <Avatar
            alt="Remy Sharp"
            className={classes.large}
            src={supplierBio.customerBiometricData}
          />
        </div>
      );
    }
  }

  function loadProfileData() {
    if (supplierDetails != null) {
      return (
        <div>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {supplierDetails.firstName +
              " " +
              supplierDetails.secondName +
              " " +
              supplierDetails.lastName}
          </Typography>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {supplierDetails.address1 + " " + supplierDetails.address2}
          </Typography>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {supplierDetails.nic}
          </Typography>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            {supplierDetails.mobileNo}
          </Typography>
        </div>
      );
    } else {
      return (
        <div className={classes.rootx}>
          <CircularProgress color="primary" />
        </div>
      );
    }
  }

  async function getLastCollection() {
    const result = await services.getLastCollectionDetailsByCustomerID(id);
    setLastCollection(result);
  }

  async function getLastAdvance() {
    const result = await services.GetLastAdvancedDetailsByCustomerID(id);
    if (result != null) {
    setLastAdvance(result);
    }
  }

  async function getLastPayment() {
    const result = await services.GetLastPaymentDetailsByCustomerID(id);
    if (result != null) {
    setLastPayment(result);
    }
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <PageHeader
                title="View Customer details"
                isButtonEnable={true}
                buttonText="Back to Listing"
                path="/Customer"
      />
      <hr />
    <div className={classes.root}>
      <AppBar position="static" color={classes.bar}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          className={classes.txt}
        >
          <Tab label="Info" {...a11yProps(0)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            {setAvatar()}
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.title}>
              <h5>
                <b>Supplier Profile</b>{" "}
              </h5>
            </Typography>

            <Divider />
            {loadProfileData()}
          </Grid>

          <Grid item xs={3}>
            <Card className={classes.card4} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b> Last Collection</b>
                </Typography>

                <Typography
                  className={classes.title}
                  color="textSecondary"
                  display="inline"
                >
                  <List>
                    {lastCollection.map((s) => {
                      return (
                        <ListItem>
                          <ListItemIcon>
                            <EcoIcon color="secondary" />
                          </ListItemIcon>
                          <ListItemText primary={s.collectionTypeName} />
                          <ListItemSecondaryAction>
                            <CountUp
                              end={s.totalAmount}
                              decimals={2}
                              decimal="."
                              suffix="Kg"
                            />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={3}>
            <CollectionCount id={id} />
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Card className={classes.card2} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b>Running Balance</b>
                </Typography>
                <br />
                <Typography
                  className={classes.centertitleCurrency}
                  component="h2"
                >
                  <CountUp
                    end={balance.runningBalance}
                    decimals={2}
                    decimal="."
                    prefix="Rs: "
                  />
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6}>
            <Card className={classes.card2} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b>Current Balance</b>
                </Typography>
                <br />
                <Typography
                  className={classes.centertitleCurrency}
                  component="h2"
                >
                  <CountUp
                    end={balance.currentBalance}
                    decimals={2}
                    decimal="."
                    prefix="Rs: "
                  />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Card className={classes.card3} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b> Last Advance</b>
                </Typography>
                <br />
                <Typography className={classes.title} color="textSecondary">
                    Date :{lastAdvance.issuedDate}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                    Amount :{" "}
                    <CountUp
                      end={lastAdvance.advanceAmount}
                      decimals={2}
                      decimal="."
                      prefix="Rs: "
                    />
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={3}>
            <Card className={classes.card3} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b> Last Payment Details</b>
                </Typography>
                <br />
                <Typography className={classes.title} color="textSecondary">
                    Date : {lastPayment.issuedDate}
                </Typography>
                <Typography className={classes.title} color="textSecondary">
                 
                    Amount :{" "}
                    <CountUp
                      end={lastPayment.paidAmount}
                      decimals={2}
                      decimal="."
                      prefix="Rs: "
                    />
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={3}>
            <Card className={classes.card3} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b> Factory Items</b>
                  <br />
                  <br />
                  <Typography className={classes.title} color="textSecondary">
                    Requested Date: {factoryItems.createdDate}
                  </Typography>
                  <Typography className={classes.title} color="textSecondary">
                    Requested Quantity: {factoryItems.requestedQuantity}
                  </Typography>
                  <Typography className={classes.title} color="textSecondary">
                    Approved Quantity: {factoryItems.approvedQuantity}
                  </Typography>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={3}>
            <Card className={classes.card3} boxShadow={3}>
              <CardContent>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  <b> Loan</b>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <br />
      </TabPanel>

      <TabPanel value={value} index={1}>
        Item Two
      </TabPanel>
      <TabPanel value={value} index={2}>
        Item Three
      </TabPanel>
    </div>
    </div>
    </div>
    </div>
    </Fragment>
  );
}
